import $ from 'jquery';

const selectList = () => {

	$(document)
		// STEP 1
		.on('click', '.js-select-list-step1-link', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $step1 = $this.closest('.select-list');
			var $step1Item = $this.closest('li');
			var $step1Items = $step1.find('li');
			var $step1Value = $step1.find('.select-list__value');
			var step1DefaultValue = '- vyberte typ zařízení -';
			var $step2List = $('.js-select-list-step2');
			var $step2 = $step2List.closest('.select-list');
			var $step2Value = $step2.find('.select-list__value');
			var step2DefaultValue = '- vyberte model zařízení -';

			$step1.removeClass('select-list--open');
			$step1Item.addClass('select-list__item--selected');
			$step1Value.text( $this.text() );

			$.ajax({
				url: skwp.ajax_url,
				type: 'post',
				data: {
					action: 'ajax_guide',
					term_slug: $(this).data('term_slug'),
				},
				beforeSend: function(){
					$step2Value.text( '- načítám -' );
				}
			})
			.done(function(response){
				if ( response.success ) {
					var $items = $(response.data);
					// remove all items
					$step2List.find('li').remove();
					// add new items
					$items.appendTo($step2List);
					$step2.removeClass('select-list--disabled');
					$step2Value.text( step2DefaultValue );
				} else {
					var $items = $step2.find('li');
					$items.remove();
					$step2.addClass('select-list--disabled');

					$step1Items.removeClass('select-list__item--selected');
					$step1Value = step1DefaultValue;
				}
			});
		});

};

exports.init = selectList;



// WEBPACK FOOTER //
// ./src/js/components/selectList.js